// filepath: g:\Development\Projects\familysync\frontend\src\store\slices\usersSlice.js
// File Metadata:
// Filename: usersSlice.js
// Version: 1.01
// Created: 2025-04-24 00:00:00
// Last Modified: 2025-05-03
// Authors: GitHub Copilot
// Description: Redux slice for managing users and family members data

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../api/axiosInstance';

// Async thunk to fetch all users (family members)
export const fetchUsers = createAsyncThunk(
  'users/fetchUsers',
  async (_, { rejectWithValue }) => {
    try {
      // axiosInstance automatically adds the token and handles credentials
      const response = await axiosInstance.get('/users');
      return response.data;
    } catch (error) {
      console.error('Error fetching users:', error);
      return rejectWithValue(error.response?.data?.error || error.message);
    }
  }
);

const usersSlice = createSlice({
  name: 'users',
  initialState: {
    users: [],
    status: 'idle', // 'idle', 'loading', 'succeeded', 'failed'
    error: null
  },
  reducers: {
    // Add any additional reducers here if needed
    updateUserStatus: (state, action) => {
      const { userId, status } = action.payload;
      const userIndex = state.users.findIndex(user => user._id === userId);
      if (userIndex !== -1) {
        state.users[userIndex].status = status;
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.users = action.payload;
        state.error = null;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  }
});

export const { updateUserStatus } = usersSlice.actions;

// Selector to get all family members
export const selectFamilyMembers = (state) => state.users.users;

export default usersSlice.reducer;